/**
 * Checks if the client meets all of the following requirements to help ensure the data is coming
 * from modern browsers and presumably a higher performing device:
 *  - Supports Map, ResizeObserver, and sendBeacon.
 *  - When supported, respect the clients choice for "saveData". If true, do not make any network
 *    calls.
 *  - When supported, checks the effective connection type is categorized as having a 4g or higher
 *    speed. This increases the confidence that the dimensions received represent fully loaded
 *    embeds.
 * @param  {Number} options.sample_rate - Rate at which to sample running this module (between 0
 * and 1).
 * @return {Boolean}
 */
var isEligible = function isEligible() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$sample_rate = options.sample_rate,
      sample_rate = _options$sample_rate === void 0 ? 1 : _options$sample_rate;
  var eligible = false;
  /**
   * All clients are required to support the following APIs. This should include the last few
   * versions of Edge, Firefox, Chrome, Safari, and Opera.
   */

  if (Math.random() <= sample_rate && typeof window !== 'undefined' && typeof navigator !== 'undefined' && 'Map' in window && 'ResizeObserver' in window && 'sendBeacon' in navigator) {
    eligible = true;
  }
  /**
   * The following criteria should only apply if the client supports them. This includes Edge,
   * Chrome and Opera.
   */


  if ('connection' in navigator && 'effectiveType' in navigator.connection && 'saveData' in navigator.connection // Not eligible if effective type is not 4g OR save data is true
  && (navigator.connection.effectiveType !== '4g' || navigator.connection.saveData)) {
    eligible = false;
  } // If this is an end to end test, ignore all other conditions and force eligibility to true.


  if (window.location.search.includes('e2e_test')) {
    eligible = true;
  }

  return eligible;
};

export { isEligible };
